export const enable_purchase_credits_flag = "enable-credit-purchase";
export const enable_manage_subscription_flag = "enable-manage-subscription";
export const enable_react_scan_flag = "enable-react-scan";
export const enable_logs_flag = "enable-logs";
export const enable_visualization_config_download_flag = "enable-visualization-config-download";
export const enable_promptbook_variables_flag = "enable-promptbook-variables";
export const enable_deployment_panel_flag = "enable-deployment-panel";
export const enable_promptbook_result_panel_flag = "enable-promptbook-result-panel";
export const enable_promptbook_process_tab_flag = "enable-promptbook-process-tab";
export const enable_promptbook_onboarding_flag = "enable-promptbook-onboarding";
export const enable_promptbook_status_bar_flag = "enable-promptbook-status-bar";
export const enable_promptbook_templates_flag = "enable-promptbook-templates";
export const enable_promptbook_executable_code_flag = "enable-promptbook-executable-code";
export const enable_semantic_model_page_flag = "enable-semantic-model-page";
export const enable_registration_flag = "enable-registration-flag";
